import { c as _c } from "react/compiler-runtime";
import { CoinInterface } from "@/app/interfaces/coin.interface";
import { useLanguage } from "@/app/context/LanguageContext";
import { useCoinsContext } from "@/app/context/MarketContext";
export const useCoinNameFromSymbol = () => {
  const $ = _c(3);
  const {
    lang
  } = useLanguage();
  const {
    coins
  } = useCoinsContext();
  let t0;
  if ($[0] !== coins || $[1] !== lang) {
    t0 = symbol => getCoinNameFromSymbol2(symbol, coins ?? [], lang);
    $[0] = coins;
    $[1] = lang;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export function getCoinNameFromSymbol2(symbol: string | undefined, coins: CoinInterface[] = [], lang: string = "fa"): string {
  const safeCoinsList = Array.isArray(coins) ? coins : [];
  const normalizedSymbol = symbol?.toLowerCase();
  const coin = safeCoinsList.find(coin => coin.symbol?.toLowerCase() === normalizedSymbol);
  const nameFromLang = coin?.name?.[lang as keyof typeof coin.name];
  return (nameFromLang ?? coin?.name?.en ?? coin?.name?.fa ?? symbol ?? "") as string;
}
export default function getCoinNameFromSymbol(symbol: string | undefined, coins: CoinInterface[] = [], lang: string = "fa"): string {
  return getCoinNameFromSymbol2(symbol, coins, lang);
}